import axios from 'axios';
import { tApi } from 'tplus-api';

export default class QueryApi {

  static async webapiProxyReq(...args) {
    const resp = await tApi(...args);
    // let json = resp.data;
    // if(typeof(json) == 'string'){
    //   json = JSON.parse(resp.data.Value);
    // }
    return resp;
  }

  // 枚举
  static async getEnumByName(enumName) {
    const method = 'chanjet.eap.Enum.getEnumByName';
    const resp = await this.webapiProxyReq({ enumName: enumName }, method, false);
    return resp;
    // return {"Id":"89","Name":"DeliveryMode","Title":"运输方式","Custom":true,"EnumType":2,"CustomUser":0,"Showcode":true,"Showremark":false,"ShowIndex":0,"Items":[{"Id":"70129","Code":"0001","Name":"航空运输","Position":1,"CustomUse":false,"IsDelete":0,"IsExtend":1,"remark":null,"DefaultValue":"0","EnumId":"89"},{"Id":"70130","Code":"0002","Name":"物流","Position":2,"CustomUse":false,"IsDelete":0,"IsExtend":1,"remark":null,"DefaultValue":"0","EnumId":"89"},{"Id":"70131","Code":"0003","Name":"大货","Position":3,"CustomUse":false,"IsDelete":0,"IsExtend":1,"remark":null,"DefaultValue":"0","EnumId":"89"},{"Id":"70132","Code":"0004","Name":"车皮","Position":4,"CustomUse":false,"IsDelete":0,"IsExtend":1,"remark":null,"DefaultValue":"0","EnumId":"89"}]}}
  }

  // 存货自由项
  static async GetInvFreeItemsDetails(fieldName,ID) {
    const method = 'chanjet.AA.MB.MBAAInventory.GetInvFreeItemsDetails';
    let resp = await this.webapiProxyReq({ID}, method, true);
    if(resp && resp.InvFreeItemsDetailEntity){
      let reslut = resp.InvFreeItemsDetailEntity.find(item=>{
         return item.Name.toLowerCase() === fieldName.toLowerCase();
      });
      resp = {
        Custom: true,
        Items: reslut.Value.map(item =>{
          return {Id: item, Code: "001", Name:item}
        }),
        Title: reslut.Title
      }
      return resp;
    }
    return {Items:[]};
  }

  // 单据自定义项
  static async GetVoucherEnumOrRefSetItem(params) {
    const method = 'chanjet.eap.RefList.GetVoucherEnumOrRefSetItem';
    const resp = await this.webapiProxyReq(params, method, false);
    return resp;
    // return [{ "IsNextPage": true, "RefTitleInfo": ["returnValue", "名称", "编码"], "RefValueList": { "RefValueInfo": [["01", "01", "01"], ["02", "02", "02"], ["03", "03", "03"], ["04", "04", "04"]] }, "WeakTypeDtoName": null, "DtoClassName": "Ufida.T.EAP.DataStruct.RefListInfo", "IsWeakType": false, "AliName": "RefListInfo", "Status": 0, "EnableHasChanged": false, "ChangedProperty": [], "DynamicPropertyKeys": [], "DynamicPropertyValues": [], "ID": null, "DeleteID": null, "Name": null, "Code": null, "Updated": "\/Date(1563415375575)\/", "UpdatedBy": null, "InnerSearchLevel": 0, "RecordChange": true, "InnerPropInParentRecure": null, "Ts": null, "CaseSensitive": false, "RecordDynamicNullValue": false, "data": null }]
  }

  // 参照
  static async GetDropDownData(params) {
    const method = 'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetDropDownData';
    const resp = await this.webapiProxyReq({ para: params }, method, false);
    return resp;
    // return {"Id":"89","Name":"DeliveryMode","Title":"运输方式","Custom":true,"EnumType":2,"CustomUser":0,"Showcode":true,"Showremark":false,"ShowIndex":0,"Items":[{"Id":"70129","Code":"0001","Name":"航空运输","Position":1,"CustomUse":false,"IsDelete":0,"IsExtend":1,"remark":null,"DefaultValue":"0","EnumId":"89"},{"Id":"70130","Code":"0002","Name":"物流","Position":2,"CustomUse":false,"IsDelete":0,"IsExtend":1,"remark":null,"DefaultValue":"0","EnumId":"89"},{"Id":"70131","Code":"0003","Name":"大货","Position":3,"CustomUse":false,"IsDelete":0,"IsExtend":1,"remark":null,"DefaultValue":"0","EnumId":"89"},{"Id":"70132","Code":"0004","Name":"车皮","Position":4,"CustomUse":false,"IsDelete":0,"IsExtend":1,"remark":null,"DefaultValue":"0","EnumId":"89"}]}}
  }

  static async GetDropDownDataByMethod(params,method ){
    const resp = await this.webapiProxyReq({ ...params }, method, false);
    return resp;
  }

  // 获取参照基本信息
  static async getRefBase(key) {
    const method = 'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetRefBaseInfo';
    const resp = await this.webapiProxyReq({ key }, method, false);
    return resp;
  }

  // 获取参照列信息
  static async getRefColumnSets(refDataSourceKey, refObject) {
    const method = 'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetColumnCaption';

    const resp = await this.webapiProxyReq({ refDataSourceKey, refObject }, method, false);
    return resp.Data;
  }

  // 获取参照数据信息
  static async getRefData(type, args) {
    const method = type === 'DropDownList' ?
      'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetItemList' :
      'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetDropDownData';
    const resp = await this.webapiProxyReq({ para: args }, method, false);
    return resp.Data;
  }

  //获取枚举信息
  static async getEnumItems(args) {
    const method = 'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetEnumItems';
    const resp = await this.webapiProxyReq({ para: args }, method, false);
    return resp;
  }
























  // // 获取查询项
  // static async getPlanItems(planId) {
  //   const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.GetMBPlanItems';
  //   const resp = await this.webapiProxyReq({ planId }, method, false);
  //   return resp.data;
  // }

  // // 获取上次查询数据
  // static async getPlanData(planId) {
  //   const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.GetMBPlanData';
  //   const resp = await this.webapiProxyReq({ planId }, method, false);
  //   return resp.data;
  // }



  // //保存
  // static async savePlanData(planId, data) {
  //   const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.SaveMBPlanData';
  //   const resp = await this.webapiProxyReq({ planId, data }, method, false);
  //   return resp.data;
  // }

  // //保存
  // static async copyPlanData(planId, data) {
  //   const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.CopyMBSearchPlan';
  //   const resp = await this.webapiProxyReq({ planId, data }, method, false);
  //   return resp.data;
  // }

  // //保存
  // static async copyPlanData(planId, data) {
  //   const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.CopyMBSearchPlan';
  //   const resp = await this.webapiProxyReq({ planId, data }, method, false);
  //   return resp.data;
  // }

  // //获取二次过滤项
  // static async getReportColumnFilterItems(args) {
  //   const method = 'chanjet.EAP.Report.MobileReportApi.GetReportColumnFilterItems';
  //   const resp = await this.webapiProxyReq({
  //     dto: {
  //       ...args
  //     }
  //   }, method, false);
  //   return resp;
  // }

  // static async getSqlTable(args) {
  //   const method = 'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetSqlTable';
  //   const resp = await this.webapiProxyReq({
  //     para: args
  //   }
  //     , method, false);
  //   return resp.Data;
  // }
}
